import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
const ResourceBaseUrl = '/admin/resource'

export async function queryResource(params) {
  const result = await request({
    url: ResourceBaseUrl,
    method: 'GET',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Query resource failed!') ?? {}
}

export async function createResource(data) {
  const result = await request({
    url: ResourceBaseUrl,
    method: 'POST',
    data
  })
  return ResultHandler(result, 'Create resource failed!') ?? []
}

export async function updateResource(data) {
  const result = await request({
    url: ResourceBaseUrl,
    method: 'PUT',
    data
  })
  return ResultHandler(result, 'Update resource failed!') ?? []
}
export async function removeResource(id) {
  const result = await request({
    url: ResourceBaseUrl,
    method: 'DELETE',
    params: { id }
  })
  return ResultHandler(result, 'Update resource failed!') ?? []
}
